import type { FC } from 'react'

import { Table } from '@skytech/ui'
import { Td } from '@skytech/ui/Table/Td'
import { useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'
import { LocalDate } from '@/components/LocalDate'
import { getApplications } from '@/ducks/customerReducer'
import { getInsuranceTypeTextIdFromCode } from '@/util/customers'

import './credit-frame-application-list.scss'

const CreditFrameApplicationList: FC = () => {
  const applications = useSelector(getApplications)

  if (applications.length === 0) return null

  return (
    <div className="credit-frame-application-list">
      <Table rowHeight="tall">
        <thead>
          <tr>
            <th>
              <Translation id="status" />
            </th>

            <th className="number px-12 text-left">
              <Translation id="amount" />
            </th>

            <th className="px-4 text-left">
              <Translation id="insurance" />
            </th>

            <th className="px-4 text-left">
              <Translation id="signatory" />
            </th>

            <th className="px-4 text-left">
              <Translation id="supplier" />
            </th>

            <th className="px-4 text-left">
              <Translation id="period" />
            </th>

            <th className="px-4 text-left">
              <Translation id="created" />
            </th>

            <th className="px-4 text-left">
              <Translation id="updated" />
            </th>
          </tr>
        </thead>

        <tbody>
          {applications.map((application: any) => (
            <Application key={application.id} {...application} />
          ))}
        </tbody>
      </Table>
    </div>
  )
}

const Application: FC<any> = ({
  application_amount,
  granted_amount,
  signee,
  contact_phone,
  contact_mail,
  vendor_name,
  vendor_org_number,
  vendor_contact,
  created_date,
  edited_date,
  status,
  insurance,
  approval_date,
  expiration_date,
}) => (
  <tr>
    <Td>{status}</Td>

    <Td className="text-right">
      <FormattedNumberWithCurrency amount={application_amount} />
      <br />
      <FormattedNumberWithCurrency amount={granted_amount} />
    </Td>

    <Td>
      <Translation id={getInsuranceTypeTextIdFromCode(insurance)} />
    </Td>

    <Td>
      {signee}
      <br />
      {contact_phone}
      <br />
      {contact_mail}
    </Td>

    <Td>
      {vendor_name}
      <br />
      {vendor_org_number}
      <br />
      {vendor_contact}
    </Td>

    <Td>
      <LocalDate date={approval_date} />
      <br />
      <LocalDate date={expiration_date} />
    </Td>

    <Td>
      <LocalDate date={created_date} />
    </Td>

    <Td>
      <LocalDate date={edited_date} />
    </Td>
  </tr>
)

export default CreditFrameApplicationList
